import { render, staticRenderFns } from "./DefaultPageWithIconClassifier.vue?vue&type=template&id=8a689a46&scoped=true&"
import script from "./DefaultPageWithIconClassifier.vue?vue&type=script&lang=ts&"
export * from "./DefaultPageWithIconClassifier.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultPageWithIconClassifier.vue?vue&type=style&index=0&id=8a689a46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a689a46",
  null
  
)

export default component.exports